import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAsyncCouponCreate,
  createdCoupon,
  fetchAsyncCoupon,
} from "./CouponSlice";
import "../../css/CouponCreate.css";
import { useHistory } from "react-router-dom";
import { TimeConverter } from "../../utils/TimeConverter";
import { DateConverter } from "../../utils/DateConverter";
import { format } from "date-fns";

const CouponCreate: React.FC = () => {
  const [couponName, setCouponName] = useState(""); //クーポン名
  const [couponInfo, setCouponInfo] = useState(""); //クーポン情報
  const [couponDiscount, setCouponDiscount] = useState(185); //割引額
  const [couponType, setCouponType] = useState(0); //割引タイプ
  const [getLimitInput, setGetLimitInput] = useState(""); //発行上限

  //今の日時を初期値に
  const today = new Date();
  const todayString = format(today, "yyyy-MM-dd HH:mm:ss");
  const [startDate, setStartDate] = useState(todayString); //有効期間開始日付
  const [expiry, setExpiry] = useState(todayString); //有効期限

  const [isReuseable, setIsReuseable] = useState(0); //再利用
  const [isSingleUse, setIsSingleUse] = useState(0); //再発行
  const [isWeekend, setIsWeekend] = useState(0); //平日or休日
  const [timeConstraint, setTimeConstraint] = useState(1); //時間制約の有無
  const [availableStartTime, setAvailableStartTime] = useState("00:00"); //開始時刻
  const [availableEndTime, setAvailableEndTime] = useState("23:59"); //終了時刻

  // const isTimeDisabled = timeConstraint === 0; //開始時刻、終了時刻のグレーアウト制御
  const isCouponnameValid = couponName.length <= 8; //couponnameバリデーション
  const navigate = useHistory();

  const dispatch = useDispatch();

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const getLimitValue = getLimitInput === "" ? 0 : getLimitInput;
    const formData = {
      coupon_name: couponName,
      coupon_info: couponInfo,
      coupon_discount: couponDiscount,
      coupon_type: couponType,
      get_count: 0,
      get_limit: getLimitValue,
      start_date: DateConverter(startDate, { timezone: "UTC" }),
      expiry: DateConverter(expiry, { timezone: "UTC" }),
      is_reusable: isReuseable,
      is_single_use: isSingleUse,
      is_weekend: isWeekend,
      time_limit: timeConstraint,
      available_start_time: TimeConverter(availableStartTime, {
        timezone: "UTC",
        formatString: "HH:mm",
      }),
      available_end_time: TimeConverter(availableEndTime, {
        timezone: "UTC",
        formatString: "HH:mm",
      }),
    };
    await dispatch(fetchAsyncCouponCreate(formData)).unwrap();
    await dispatch(fetchAsyncCoupon()).unwrap(); // クーポンリストを再取得
    navigate.push("/Coupon");
  };

  return (
    <div className="position_row">
      <div className="coupon_create_container">
        <h1 className="coupon_create_title">クーポン新規作成</h1>
        <div className="coupon_back_button_container"></div>
        <form className="coupon_create_form" onSubmit={handleSubmit}>
          <h2 className="coupon_id_form font_coupon_form">クーポン名</h2>
          <span className="coupon_id_detail">英数字8文字以内</span>
          <input
            type="text"
            value={couponName}
            onChange={(e) => setCouponName(e.target.value)}
            className="coupon_id_input"
            required
          />
          {!isCouponnameValid && (
            <span style={{ color: "red" }}>8文字を超えることはできません</span>
          )}
          <h2 className="coupon_info_form font_coupon_form">情報</h2>
          <span className="coupon_info_detail">
            ＊アプリ内からユーザに見られます
          </span>
          <input
            type="textarea"
            value={couponInfo}
            onChange={(e) => setCouponInfo(e.target.value)}
            className="coupon_info_input"
            required
          />
          <h2 className="coupon_content_form font_coupon_form">内容</h2>
          <span className="coupon_content_detail">
            料金体系 : 初乗り10分185円・以降15円/分
          </span>
          <div className="coupon_content_input">
            <input
              type="number"
              value={couponDiscount}
              onChange={(e) => setCouponDiscount(Number(e.target.value))}
              required
            />
            <select
              value={couponType}
              onChange={(e) => setCouponType(Number(e.target.value))}
              required>
              <option value="0">円</option>
              <option value="1">%</option>
              <option value="2">分</option>
            </select>
            <span className="font_coupon_form">引き</span>
          </div>
          <h2 className="get_limit_form font_coupon_form">発行枚数上限</h2>
          <span className="get_limit_detail">
            発行枚数上限を超えるとユーザは発行できなくなります
          </span>
          <input
            type="number"
            placeholder="無制限"
            value={getLimitInput}
            onChange={(e) => setGetLimitInput(e.target.value)}
            className="get_limit_input"></input>
          <h2 className="start_date_form font_coupon_form">有効期間開始日</h2>
          <input
            type="datetime-local"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="start_date_input"
            required
          />
          <h2 className="expiry_form font_coupon_form">有効期限</h2>
          <input
            type="datetime-local"
            value={expiry}
            onChange={(e) => setExpiry(e.target.value)}
            className="expiry_input"
            required
          />
          <h2 className="is_reusable_form font_coupon_form">再利用</h2>
          <span className="is_reusable_detail">
            利用後にクーポンが削除される→「できない」
          </span>
          <select
            value={isReuseable}
            onChange={(e) => setIsReuseable(Number(e.target.value))}
            className="is_reusable_input"
            required>
            <option value="0">できない</option>
            <option value="1">できる</option>
          </select>
          <h2 className="is_single_use_form font_coupon_form">再発行</h2>
          <span className="is_single_use_detail">
            利用後再発行できない→「できない」
          </span>
          <select
            value={isSingleUse}
            onChange={(e) => setIsSingleUse(Number(e.target.value))}
            className="is_single_use_input"
            required>
            <option value="0">できない</option>
            <option value="1">できる</option>
          </select>
          <h2 className="is_weekend_form font_coupon_form">平日or休日</h2>
          <select
            value={isWeekend}
            onChange={(e) => setIsWeekend(Number(e.target.value))}
            className="is_weekend_input"
            required>
            <option value="0">どちらも</option>
          </select>
          {/* <h2 className="time_limit_form font_coupon_form">時間制約</h2>
          <span className="time_limit_detail">
            朝活クーポンはここが「あり」に該当します
          </span>
          <select
            value={timeConstraint}
            onChange={(e) => setTimeConstraint(Number(e.target.value))}
            className="time_limit_input"
            required>
            <option value="0">なし</option>
            <option value="1">あり</option>
          </select> */}
          <h2 className="available_start_time_form font_coupon_form">
            開始時刻
          </h2>
          <input
            type="time"
            // disabled={isTimeDisabled}
            className={
              // isTimeDisabled ? "disabled-input" :
              "available_start_time_input"
            }
            value={availableStartTime}
            onChange={(e) => setAvailableStartTime(e.target.value)}
          />
          <h2 className="available_end_time_form font_coupon_form">終了時刻</h2>
          <input
            type="time"
            value={availableEndTime}
            onChange={(e) => setAvailableEndTime(e.target.value)}
            // disabled={isTimeDisabled}
            className={
              // isTimeDisabled ? "disabled-input" :
              "available_end_time_input"
            }
          />
          <div className="submit_button_container">
            <input
              type="submit"
              className="submit_button"
              disabled={!isCouponnameValid}
              value="確定"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default CouponCreate;
